var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFintech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 86,
    viewBox: "0 0 91 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#DAF3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13252_5053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6063 28.3686V21.8125M30.3906 28.4837V21.8125",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3918 21.682C31.6782 21.682 32.7211 20.6391 32.7211 19.3527C32.7211 18.0663 31.6782 17.0234 30.3918 17.0234C29.1054 17.0234 28.0625 18.0663 28.0625 19.3527C28.0625 20.6391 29.1054 21.682 30.3918 21.682Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6105 21.682C40.897 21.682 41.9398 20.6391 41.9398 19.3527C41.9398 18.0663 40.897 17.0234 39.6105 17.0234C38.3241 17.0234 37.2812 18.0663 37.2812 19.3527C37.2812 20.6391 38.3241 21.682 39.6105 21.682Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7734 25.5234C18.2836 25.5234 19.5078 24.2992 19.5078 22.7891C19.5078 21.2789 18.2836 20.0547 16.7734 20.0547C15.2633 20.0547 14.0391 21.2789 14.0391 22.7891C14.0391 24.2992 15.2633 25.5234 16.7734 25.5234Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1256 32.0298V29.0138C22.1256 28.4551 21.9037 27.9193 21.5087 27.5244L18.9219 24.9375",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2188 25.5234C54.7289 25.5234 55.9531 24.2992 55.9531 22.7891C55.9531 21.2789 54.7289 20.0547 53.2188 20.0547C51.7086 20.0547 50.4844 21.2789 50.4844 22.7891C50.4844 24.2992 51.7086 25.5234 53.2188 25.5234Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8666 31.8931V29.0141C47.8666 28.4555 48.0885 27.9197 48.4835 27.5247L51.1488 24.8594M12.4145 55.6051H5.8125M12.5315 46.3894H5.8125",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35272 57.9359C4.63914 57.9359 5.68199 56.893 5.68199 55.6066C5.68199 54.3202 4.63914 53.2773 3.35272 53.2773C2.06629 53.2773 1.02344 54.3202 1.02344 55.6066C1.02344 56.893 2.06629 57.9359 3.35272 57.9359Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35272 48.7211C4.63914 48.7211 5.68199 47.6782 5.68199 46.3918C5.68199 45.1054 4.63914 44.0625 3.35272 44.0625C2.06629 44.0625 1.02344 45.1054 1.02344 46.3918C1.02344 47.6782 2.06629 48.7211 3.35272 48.7211Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78906 71.957C8.29922 71.957 9.52344 70.7328 9.52344 69.2227C9.52344 67.7125 8.29922 66.4883 6.78906 66.4883C5.27891 66.4883 4.05469 67.7125 4.05469 69.2227C4.05469 70.7328 5.27891 71.957 6.78906 71.957Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0086 63.8672H13.0177C12.4591 63.8672 11.9234 64.0891 11.5283 64.4841L8.82812 67.1843",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78906 35.5078C8.29922 35.5078 9.52344 34.2836 9.52344 32.7734C9.52344 31.2633 8.29922 30.0391 6.78906 30.0391C5.27891 30.0391 4.05469 31.2633 4.05469 32.7734C4.05469 34.2836 5.27891 35.5078 6.78906 35.5078Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0313 38.1271H13.0153C12.4567 38.1272 11.9209 37.9053 11.5259 37.5103L8.89844 34.8828M39.6063 73.4622V80.1813M30.3906 73.599V80.1813",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6105 84.9711C40.897 84.9711 41.9398 83.9282 41.9398 82.6418C41.9398 81.3554 40.897 80.3125 39.6105 80.3125C38.3241 80.3125 37.2812 81.3554 37.2812 82.6418C37.2812 83.9282 38.3241 84.9711 39.6105 84.9711Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3918 84.9711C31.6782 84.9711 32.7211 83.9282 32.7211 82.6418C32.7211 81.3554 31.6782 80.3125 30.3918 80.3125C29.1054 80.3125 28.0625 81.3554 28.0625 82.6418C28.0625 83.9282 29.1054 84.9711 30.3918 84.9711Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2188 81.9414C54.7289 81.9414 55.9531 80.7172 55.9531 79.207C55.9531 77.6969 54.7289 76.4727 53.2188 76.4727C51.7086 76.4727 50.4844 77.6969 50.4844 79.207C50.4844 80.7172 51.7086 81.9414 53.2188 81.9414Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8672 70.1016V72.9807C47.8672 73.5394 48.0891 74.0752 48.4841 74.4701L51.1873 77.1733",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7734 81.9414C18.2836 81.9414 19.5078 80.7172 19.5078 79.207C19.5078 77.6969 18.2836 76.4727 16.7734 76.4727C15.2633 76.4727 14.0391 77.6969 14.0391 79.207C14.0391 80.7172 15.2633 81.9414 16.7734 81.9414Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1283 70.1024V72.9816C22.1283 73.5402 21.9064 74.076 21.5114 74.471L18.8984 77.084M57.4982 46.3906H64.1824M57.4982 55.6063H64.1824",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6418 48.7211C67.9282 48.7211 68.9711 47.6782 68.9711 46.3918C68.9711 45.1054 67.9282 44.0625 66.6418 44.0625C65.3554 44.0625 64.3125 45.1054 64.3125 46.3918C64.3125 47.6782 65.3554 48.7211 66.6418 48.7211Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6418 57.9359C67.9282 57.9359 68.9711 56.893 68.9711 55.6066C68.9711 54.3202 67.9282 53.2773 66.6418 53.2773C65.3554 53.2773 64.3125 54.3202 64.3125 55.6066C64.3125 56.893 65.3554 57.9359 66.6418 57.9359Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2031 35.5078C64.7133 35.5078 65.9375 34.2836 65.9375 32.7734C65.9375 31.2633 64.7133 30.0391 63.2031 30.0391C61.693 30.0391 60.4688 31.2633 60.4688 32.7734C60.4688 34.2836 61.693 35.5078 63.2031 35.5078Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9688 38.1264H56.9845C57.5431 38.1264 58.0789 37.9045 58.4739 37.5095L61.0694 34.9141",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2031 71.957C64.7133 71.957 65.9375 70.7328 65.9375 69.2227C65.9375 67.7125 64.7133 66.4883 63.2031 66.4883C61.693 66.4883 60.4688 67.7125 60.4688 69.2227C60.4688 70.7328 61.693 71.957 63.2031 71.957Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0625 63.8672H56.9794C57.538 63.8672 58.0738 64.0891 58.4688 64.4841L61.1197 67.1349",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9937 73.8038C47.5892 73.8038 57.7999 63.5931 57.7999 50.9976C57.7999 38.4021 47.5892 28.1914 34.9937 28.1914C22.3982 28.1914 12.1875 38.4021 12.1875 50.9976C12.1875 63.5931 22.3982 73.8038 34.9937 73.8038Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9197 54.2814C17.7128 53.199 17.6089 52.0995 17.6094 50.9975C17.6094 44.5402 21.1272 38.9047 26.3525 35.9051M30.7918 34.1182C32.1689 33.7766 33.5825 33.6044 35.0014 33.6055C44.6072 33.6055 52.3934 41.3916 52.3934 50.9975C52.3934 57.4574 48.8729 63.0943 43.6447 66.094M19.466 58.8246C22.3303 64.4984 28.2106 68.3895 35.0014 68.3895C36.4506 68.3895 37.8588 68.2117 39.2041 67.8781",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9967 28.5312V32.7729M19.1113 35.1113L22.1106 38.1106M12.5312 50.9967H16.7729M19.1113 66.8822L22.1106 63.8829M34.9967 73.4622V69.2205M50.8822 66.8822L47.8829 63.8829M57.4622 50.9967H53.2205M50.8822 35.1113L47.8829 38.1106M37.2772 49.3549C36.8962 49.2201 36.5307 49.098 36.1825 48.9814C34.9658 48.5746 34.0047 48.2533 33.5922 47.7782C33.1471 47.2653 32.9888 46.6355 33.158 46.0508C33.245 45.7504 33.5005 45.2134 34.2358 44.9921C35.3451 44.6578 36.1382 45.0522 36.6085 45.4417C37.4251 46.1179 38.6352 46.0045 39.3116 45.1878C39.9878 44.3713 39.8742 43.1611 39.0577 42.4848C38.6641 42.1587 37.9281 41.6407 36.9163 41.3173V40.0469C36.9163 38.9867 36.0567 38.1273 34.9966 38.1273C33.9363 38.1273 33.0769 38.9868 33.0769 40.0469V41.3332C31.3209 41.8807 29.9744 43.2407 29.47 44.9836C28.9396 46.8163 29.3967 48.8019 30.6928 50.2951C31.7927 51.5625 33.3337 52.0776 34.9652 52.6229C35.2936 52.7328 35.6381 52.8478 35.9977 52.9749C37.3949 53.4688 37.4362 54.5367 37.3367 55.1292C37.1691 56.1267 36.3297 57.2046 34.8834 57.2142C33.3498 57.2244 32.9115 57.1554 31.7557 56.3992C30.8687 55.8187 29.6787 56.0674 29.0981 56.9545C28.5178 57.8418 28.7663 59.0316 29.6536 59.6121C30.9547 60.4632 31.9258 60.8282 33.0769 60.9713V61.9467C33.0769 63.0069 33.9363 63.8663 34.9966 63.8663C36.0569 63.8663 36.9163 63.0068 36.9163 61.9467V60.724C39.2702 59.9332 40.7748 57.8361 41.1228 55.7656C41.6026 52.9138 40.057 50.3375 37.2772 49.3549Z",
    stroke: "#21AAE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13252_5053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintech);
export default __webpack_public_path__ + "static/media/fintech.6a985d0001b1f501df6e7c5bff416daa.svg";
export { ForwardRef as ReactComponent };